/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { useFormikContext } from "formik";
import { Label } from '@fluentui/react';
import BasicInfoStep from '../../../Forms/Steps/BasicInfoStep';
import TextCKEditor from '../../../Forms/TextCKEditor';
import ImageUploadStep from '../../../Forms/Steps/ImageUploadStep';
import { presenterInfoFields, getHeadshotOptions } from '../Helpers/CopyAndFunctions';
import { getRequiredLabel } from '../../../Util/getRequiredLabel';

const PresenterDetailFields = () => {
  const { values, setFieldValue } = useFormikContext();
  const headshotOptions = getHeadshotOptions(values);
  const isPublished = values.publishStatus === 'Published';
  
  return (
    <>
      <BasicInfoStep fields={presenterInfoFields(isPublished)} />
      <div css={css`padding-bottom: 30px;`}>
        <ImageUploadStep options={headshotOptions} />
      </div>
      <Label>{getRequiredLabel('About The Presenter', isPublished)} <span style={{ color: '#605e5c', fontWeight: 400, fontSize: 12 }}>(supports HTML formatting)</span></Label>
      <TextCKEditor 
        value={values.presenterAbout} 
        onChange={(val) => setFieldValue('presenterAbout', val)} 
      />
    </>
  );
};

export default PresenterDetailFields;
